import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import Timer from '@/components/Timer/Timer'
import { useTimer } from '@/hooks'

const ExamTimer = (props) => {
  const { timeRemaining, onTimeout, onTimeChange, isPaused } = props

  const {
    timeRemaining: displayTime,
    start,
    pause,
  } = useTimer({
    timeRemaining,
    onEnd: onTimeout,
  })

  useEffect(() => {
    start()
  }, [start])

  useEffect(() => {
    if (isPaused) {
      pause()
    } else {
      start()
    }
  }, [isPaused, pause, start])

  useEffect(() => {
    if (onTimeChange) {
      onTimeChange(displayTime)
    }
  }, [displayTime, onTimeChange])

  return <Timer className="Exam__header-timer" timeRemaining={displayTime} />
}

ExamTimer.propTypes = {
  timeRemaining: PropTypes.number,
  onTimeout: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func,
  isPaused: PropTypes.bool,
}

ExamTimer.defaultProps = {
  timeRemaining: 3600,
}

export default ExamTimer
